require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-grange-residence-dezeen-magazine.json") })
        }
      }, "path---journal-grange-residence-dezeen-magazine");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-grange-residence-dezeen-magazine!./.cache/json/journal-grange-residence-dezeen-magazine.json
// module id = 491
// module chunks = 231608221292675